import { render, staticRenderFns } from "./bankSmsValid.vue?vue&type=template&id=67efeba9&scoped=true"
import script from "./bankSmsValid.vue?vue&type=script&lang=js"
export * from "./bankSmsValid.vue?vue&type=script&lang=js"
import style0 from "./bankSmsValid.vue?vue&type=style&index=0&id=67efeba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67efeba9",
  null
  
)

export default component.exports